// Positions are sellable at +8% profit — exits fill near +8%, not the planned +10% target. Intentional, do not change to +10.
export const SELL_INDICATOR_THRESHOLD = 8;

// The same +8% as a price ratio.
export const SIMULATED_CLOSE_RATIO = 1 + SELL_INDICATOR_THRESHOLD / 100;

// Underwater buy trigger by conviction, as profit % (indicator form).
export const UNDERWATER_BUY_INDICATOR = {
    high: -3,
    regular: -5,
    low: -10,
};

// The same thresholds as price/open ratios. Regular conviction is stored as null; the key coerces to "null".
export const UNDERWATER_BUY_RATIO = {
    high: 1 + UNDERWATER_BUY_INDICATOR.high / 100,
    low: 1 + UNDERWATER_BUY_INDICATOR.low / 100,
    null: 1 + UNDERWATER_BUY_INDICATOR.regular / 100,
};

// Default buy position count per market; consumers fall back with `?? 1` for unknown markets.
export const MARKET_DEFAULT_BUY_POSITIONS = {
    stock: 6,
    crypto: 1,
};

// Long position lists render as both price edges only. The API truncates the
// actionable list to match, so these must stay in step with
// ACTIONABLE_FULL_LIST_LIMIT / ACTIONABLE_EDGE_ROWS in warren-api.
export const POSITION_LIST_FULL_LIMIT = 11;
export const POSITION_LIST_EDGE_ROWS = 5;

export const GROUP_STALE_THRESHOLD_DAYS = 330;

// Look for more positions if the price increases by 1%
// Accept slightly lower returns, but trade larger amounts for the same trading fees
// Optimization to make less trades for lower trading fees
export const ALTERNATIVE_PRICE_STEP = 1.01;

// Group default multiplier — distinct from close ratios, do not conflate.
export const LONG_BUY_DEFAULT_MULTIPLIER = 1.5;

// custom_buy values — contract shared with the API.
export const CUSTOM_BUY_TYPE = {
    LONG_EXIT: 'multiplier10p',
    BONUS_EXIT: 'bonus20p',
};

export const BASE_OVERSIZED_BUY_THRESHOLD = 10;

export const BUY_SIZE_RULE_METRICS = {
    holdings_value: 'holdings',
    price: 'price',
    free_shares: 'free shares',
};

// Position-count dropdown caps (rule config vs ad-hoc buy — kept separate).
export const MAX_BUY_SIZE_RULE_POSITIONS = 20;
export const MAX_ADHOC_BUY_POSITIONS = 80;

// buy is money out and sell is money in, the same way EventList colours an event
export const TRADE_SIDE_STYLES = {
    buy: { icon: 'box-arrow-in-down', class: 'text-danger' },
    sell: { icon: 'box-arrow-up', class: 'text-success' },
};

// the side of the eToro trade that each linkable Warren event records
export const EVENT_TRADE_SIDES = {
    buy: 'buy',
    exit: 'sell',
};
